import { createDatePreset } from "../types/interactions";
import { SessionStorageService } from "../services/sessionStorage";
export const saveCurrentSession = (options) => {
    const { viewSettings, isStandaloneMode, dateRange, selectedAccounts, selectedUsers, contextSelection } = options;
    if (!viewSettings.restoreLastSessionOnStartup || !isStandaloneMode) {
        return;
    }
    try {
        const sessionData = {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            datePreset: dateRange.preset,
            isRelativeDate: dateRange.preset !== "custom",
            startTime: dateRange.startTime,
            endTime: dateRange.endTime,
            selectedAccounts: selectedAccounts.map((acc) => acc.id),
            selectedUsers: selectedUsers.map((user) => user.id),
            accountObjects: contextSelection.accounts,
            userObjects: contextSelection.users,
            viewSettings: viewSettings,
            ...(viewSettings.selectedKPI && { selectedKPI: viewSettings.selectedKPI }),
        };
        SessionStorageService.saveSession(sessionData);
    }
    catch (error) {
        console.error("Failed to save session:", error);
    }
};
export const restoreSession = (options) => {
    var _a, _b, _c, _d;
    const { viewSettings, isStandaloneMode, setInternalDateRange, setContextSelection, updatePartialViewSettings, hidePresetsWithTransition, } = options;
    if (!viewSettings.restoreLastSessionOnStartup || !isStandaloneMode) {
        return;
    }
    try {
        const sessionData = SessionStorageService.loadSession();
        if (!sessionData)
            return;
        if (sessionData.isRelativeDate && sessionData.datePreset && sessionData.datePreset !== "custom") {
            const dateRangeToRestore = {
                ...createDatePreset(sessionData.datePreset),
                startTime: (_a = sessionData.startTime) !== null && _a !== void 0 ? _a : null,
                endTime: (_b = sessionData.endTime) !== null && _b !== void 0 ? _b : null,
            };
            setInternalDateRange(dateRangeToRestore);
        }
        else {
            setInternalDateRange({
                startDate: sessionData.startDate,
                endDate: sessionData.endDate,
                preset: "custom",
                startTime: (_c = sessionData.startTime) !== null && _c !== void 0 ? _c : null,
                endTime: (_d = sessionData.endTime) !== null && _d !== void 0 ? _d : null,
            });
        }
        if (sessionData.accountObjects || sessionData.userObjects) {
            setContextSelection({
                accountIds: sessionData.selectedAccounts,
                userIds: sessionData.selectedUsers,
                privilegeGroupIds: [],
                accounts: sessionData.accountObjects || [],
                users: sessionData.userObjects || [],
                privilegeGroups: [],
            });
        }
        if (sessionData.viewSettings) {
            updatePartialViewSettings(sessionData.viewSettings);
        }
        if (sessionData.selectedAccounts.length > 0 || sessionData.selectedUsers.length > 0) {
            hidePresetsWithTransition();
        }
    }
    catch (error) {
        console.error("Failed to restore session:", error);
    }
};
//# sourceMappingURL=sessionManagementUtils.js.map